import { render, staticRenderFns } from "./ModalRemoverConfiguracaoUpdateEnquetes.vue?vue&type=template&id=760975e7"
import script from "./ModalRemoverConfiguracaoUpdateEnquetes.vue?vue&type=script&lang=js"
export * from "./ModalRemoverConfiguracaoUpdateEnquetes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports